import { useEffect } from 'react';

import usePageTitle from '@hooks/usePageTitle/usePageTitle';
import { usePageContext } from '@providers/PageMetaProvider/model/PageContext';
import SettingsBillingManager from '@features/settings-billing/containers/SettingsBillingManager';

const pageValues = {
  title: 'Billing',
  description: 'Manage your billing settings here',
};

function SettingsBillingPage() {
  usePageTitle('ZlaytAI - Billing');
  const { setValues } = usePageContext();

  useEffect(() => {
    if (setValues) {
      setValues((prev) => ({
        ...prev,
        ...pageValues,
      }));
    }
  }, []);

  return <SettingsBillingManager />;
}

export default SettingsBillingPage;
